import { Auth } from 'aws-amplify';
import { invokeLambdaWithRetry } from 'services/Helper';
import { withArchivedQaPayload } from './archivedQaPolicy';

export function invokeArchivedQa(invoke, document, name, payload, ...options) {
  return invoke(name, withArchivedQaPayload(payload, document?.archivedQa), ...options);
}

export async function renewArchivedQaSession(archivedQa) {
  if (!archivedQa || archivedQa.standardFlow) return true;
  const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
  const response = await invokeLambdaWithRetry('instanceHandler', { body: {
    target: 'archivedQaHeartbeat', archivedQa, access_token: user.signInUserSession.idToken.jwtToken,
  } });
  if (response?.response?.success !== true) throw new Error('Archived QA protection expired. Reload before saving.');
  return true;
}

export async function fetchArchivedQaSource(submissionIdentifier, archivedQa) {
  const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
  const result = await invokeLambdaWithRetry('instanceHandler', { body: {
    target: 'fetchMsg', submissionIdentifier, archivedQa,
    access_token: user.signInUserSession.idToken.jwtToken,
  } });
  if (!Array.isArray(result?.response?.data?.listDocumentsAnyWithMsg)) throw new Error('The original QA document could not be resolved.');
  return result.response;
}

export function qaStoredValue(value, document) {
  return document?.archivedQa ? value : value.replace(/'/g, "''").replace(/"/g, '\\"');
}
